import { Feedback } from "../Models/Feedback";
import { FeedbackVote } from "../Constants/feedbackEnums";

interface IFeedbackVoteService {
  getNewCountAfterVote: (feedback: Feedback, vote: FeedbackVote) => number;
  getNewCountAfterVoteHelper: (
    prevCount: number,
    prevVote: FeedbackVote,
    vote: FeedbackVote
  ) => number;
}

class FeedbackVoteService implements IFeedbackVoteService {
  getNewCountAfterVote(feedback: Feedback, vote: FeedbackVote): number {
    let parsedExistingVote = FeedbackVote.None;
    if (feedback.loggedInUserVote) {
      parsedExistingVote = FeedbackVote[feedback.loggedInUserVote as keyof typeof FeedbackVote];
    }

    let voteCount = 0;
    if (feedback.voteCount) {
      voteCount = feedback.voteCount as number;
    }

    return this.getNewCountAfterVoteHelper(voteCount, parsedExistingVote, vote);
  }

  getNewCountAfterVoteHelper(
    prevCount: number,
    prevVote: FeedbackVote,
    vote: FeedbackVote
  ): number {
    let voteCount = prevCount;

    // update vote count
    if (prevVote === FeedbackVote.Up) {
      if (vote === FeedbackVote.None) {
        // from Up to None
        voteCount -= 1;
      } else if (vote === FeedbackVote.Down) {
        // From Up to Down
        voteCount -= 2;
      }
    } else if (prevVote === FeedbackVote.None) {
      if (vote === FeedbackVote.Up) {
        // from None to Up
        voteCount += 1;
      } else if (vote === FeedbackVote.Down) {
        // From None to Down
        voteCount -= 1;
      }
    } else if (prevVote === FeedbackVote.Down) {
      if (vote === FeedbackVote.Up) {
        // from Down to Up
        voteCount += 2;
      } else if (vote === FeedbackVote.None) {
        // From Down to None
        voteCount += 1;
      }
    }

    return voteCount;
  }
}

export const feedbackVoteService = new FeedbackVoteService();
